var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBitcoinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "#D5FD95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_367_33076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6049 22.7754C18.2251 22.7696 21.7674 22.7565 21.7266 20.5034C21.6872 18.1992 18.2849 18.3377 16.6268 18.4063C16.4416 18.4136 16.2768 18.4209 16.1426 18.4223L16.2184 22.7784C16.3278 22.7754 16.4591 22.7754 16.6049 22.7754ZM16.4328 16.4273C17.7847 16.4259 20.7349 16.4229 20.6999 14.374C20.662 12.2784 17.8284 12.4023 16.4445 12.4636C16.2884 12.4709 16.1528 12.4767 16.0391 12.4781L16.1076 16.4288L16.4328 16.4273Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2638 34.9757C22.6409 37.3134 32.1376 31.607 34.4753 22.2328C36.813 12.8572 31.1051 3.36053 21.728 1.02428C12.3567 -1.31489 2.86007 4.39303 0.523816 13.7701C-1.81389 23.1443 3.89257 32.6409 13.2653 34.9772L13.2638 34.9757ZM19.5084 10.1549C22.0663 10.3357 24.1021 11.0853 24.369 13.4245C24.5674 15.1366 23.8674 16.1793 22.7313 16.783C24.6271 17.203 25.8303 18.3041 25.6407 20.8241C25.4059 23.9522 23.0915 24.8316 19.7694 25.0795L19.8249 28.3607L17.8474 28.3972L17.7905 25.1597C17.2786 25.1684 16.7536 25.1743 16.2097 25.1714L16.268 28.4234L14.2905 28.4584L14.2321 25.1714L13.6736 25.1757C13.3907 25.1772 13.1049 25.1787 12.819 25.1845L10.2436 25.2282L10.5951 22.8599C10.5951 22.8599 12.0592 22.857 12.033 22.8351C12.593 22.8234 12.7344 22.4195 12.7651 22.1657L12.6761 16.9784L12.8176 16.9755H12.8846C12.8149 16.9675 12.7448 16.9641 12.6746 16.9653L12.6105 13.2612C12.5274 12.8616 12.259 12.4007 11.4584 12.4153C11.4803 12.3862 10.0205 12.4401 10.0205 12.4401L9.98257 10.3284L12.7126 10.2818V10.292C13.1224 10.2847 13.5438 10.2701 13.9711 10.2541L13.9157 7.00345L15.8932 6.9699L15.9486 10.1549C16.4765 10.1359 17.0074 10.1155 17.528 10.1068L17.4726 6.9422L19.4515 6.9072L19.5084 10.1578V10.1549Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_367_33076"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoinIcon);
export default __webpack_public_path__ + "static/media/bitcoin-icon.4d2dae8e431fa51fbfbcf5009ed8703c.svg";
export { ForwardRef as ReactComponent };